import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, renderSlot as _renderSlot, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5dc15d6c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 2,
  class: "flex flex-col h-full"
}
const _hoisted_2 = { class: "overflow-auto max-h-[calc(100vh-120px)]" }
const _hoisted_3 = { class: "min-w-full table-auto max-w-max" }
const _hoisted_4 = { class: "text-gray text-xs font-medium tracking-[0.5px] uppercase z-[100] border-b-neutral border-b border-solid top-0 bg-white" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "mr-0 md:mr-1" }
const _hoisted_7 = {
  key: 0,
  class: "inline-block"
}
const _hoisted_8 = {
  key: 1,
  class: "inline-block opacity-0 md:group-hover:opacity-100"
}

import { ArrowDownIcon, ArrowUpIcon } from '@heroicons/vue/24/solid';
import { ref, computed } from 'vue';
import EmptyComponent from './EmptyComponent.vue';
import LoadingComponent from './LoadingComponent.vue';

interface Column {
  name: string;
  key: string;
}

interface Data {
  [key: string]: any
}


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseTable',
  props: {
    data: {},
    columns: {},
    loading: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

const sortKey = ref();
const sortOrder = ref(0); // 0 for none, 1 for asc, -1 for desc

const sortedData = computed(() => {
  if (!sortKey.value) return props.data;

  return [...props.data].sort((a, b) => {
    if (a[sortKey.value] < b[sortKey.value]) return -sortOrder.value;
    if (a[sortKey.value] > b[sortKey.value]) return sortOrder.value;
    return 0;
  });
});

const sortData = (key: string) => {
  if (sortKey.value === key) {
    if (sortOrder.value === 0) {
      sortOrder.value = 1;
    } else if (sortOrder.value === 1) {
      sortOrder.value = -1;
    } else {
      sortOrder.value = 0;
    }
  } else {
    sortKey.value = key;
    sortOrder.value = 1;
  }
};


return (_ctx: any,_cache: any) => {
  return (!_ctx.loading && sortedData.value.length === 0)
    ? (_openBlock(), _createBlock(EmptyComponent, {
        key: 0,
        text: "Nothing was found :("
      }))
    : (_ctx.loading)
      ? (_openBlock(), _createBlock(LoadingComponent, { key: 1 }))
      : (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("table", _hoisted_3, [
              _createElementVNode("thead", _hoisted_4, [
                _createElementVNode("tr", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (column) => {
                    return (_openBlock(), _createElementBlock("th", {
                      key: column.key,
                      onClick: ($event: any) => (sortData(column.key)),
                      class: _normalizeClass([{'text-primary': sortKey.value === column.key}, "hover:text-primary leading-6 lg:leading-10 pl-2 lg:px-4 py-0 cursor-pointer group"])
                    }, [
                      _createElementVNode("span", _hoisted_6, _toDisplayString(column.name), 1),
                      (sortKey.value === column.key)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
                            (sortOrder.value > 0)
                              ? (_openBlock(), _createBlock(_unref(ArrowUpIcon), {
                                  key: 0,
                                  class: "w-3 h-3"
                                }))
                              : (sortOrder.value < 0)
                                ? (_openBlock(), _createBlock(_unref(ArrowDownIcon), {
                                    key: 1,
                                    class: "w-3 h-3"
                                  }))
                                : (_openBlock(), _createBlock(_unref(ArrowUpIcon), {
                                    key: 2,
                                    class: "w-3 h-3 text-gray hidden md:inline-block"
                                  }))
                          ]))
                        : (_openBlock(), _createElementBlock("span", _hoisted_8, [
                            _createVNode(_unref(ArrowUpIcon), { class: "w-3 h-3 text-gray" })
                          ]))
                    ], 10, _hoisted_5))
                  }), 128))
                ])
              ]),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sortedData.value, (item) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: item.key,
                    class: "border-b-neutral border-b border-solid"
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (column) => {
                      return (_openBlock(), _createElementBlock("td", {
                        key: column.key,
                        class: "p-2 lg:px-4 text-sm truncate"
                      }, [
                        _renderSlot(_ctx.$slots, column.key, { item: item }, () => [
                          _createTextVNode(_toDisplayString(item[column.key] !== null ? item[column.key] : 'unknown'), 1)
                        ])
                      ]))
                    }), 128))
                  ]))
                }), 128))
              ])
            ])
          ])
        ]))
}
}

})